import { Location } from "@angular/common";
import { Component, OnInit, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { throwError } from "rxjs";
import { map } from "rxjs/operators";
import { Counterpart } from "../../model/domain/Counterpart";
import { CounterpartAccount } from "../../model/domain/CounterpartAccount";
import { Counterpartservice } from "../../services/counterpart.service";
import { SnackbarService } from "../../services/snackbar.service";
import { ValidatorService } from "../../services/validator.service";

@Component({
  selector: "counterpart-register",
  templateUrl: "./counterpart-register.component.html",
  styleUrls: ["./counterpart-register.component.css"],
})
export class CounterpartRegisterComponent implements OnInit {
  @ViewChild("thisForm", { static: true }) public frm: NgForm;

  model: Counterpart;
  accounts: CounterpartAccount[] = [new CounterpartAccount()];
  isEditing = false;
  canValidate = false;

  constructor(
    private service: Counterpartservice,
    private router: Router,
    public validator: ValidatorService,
    private route: ActivatedRoute,
    private location: Location,
    private snackBarService: SnackbarService
  ) {}

  ngOnInit() {
    this.getCounterpart();
  }
  validators = {
    document: (value: string) =>
      this.model.document.length > 11
        ? this.validator.validateDocument(value)
        : this.validator.validatePhysicalDocument(value),
    bank: (value) => !isNaN(value),
    branch: (value) => !isNaN(value),
    account: (value) => !isNaN(value),
    selicAccount: (value) => !isNaN(value),
    cetipAccount: (value) => !isNaN(value),
    brokerAccount: (value) => !isNaN(value),
    b3Account: (value) => !isNaN(value),
  };

  getCounterpart() {
    this.model = new Counterpart();
    const id = +this.route.snapshot.paramMap.get("id");
    this.model.id = id;

    if (id) {
      this.service.GetCounterpart(id).subscribe({
        next: (q) => {
          Object.assign(this.model, q);

          if (this.model.document) {
            this.model.document = this.validator.formatDocument(
              this.model.document
            );
          }

          if (this.model.counterpartAccounts.length > 0) {
            this.accounts = this.model.counterpartAccounts;
          }

          this.isEditing = true;
          this.canValidate = true;
        },
        error: () => this.router.navigate(["/cadastro-contraparte"]),
      });
    }
  }

  submit() {
    const editing = this.isEditing;

    this.register()
      .pipe(
        map((counterpart: Counterpart) => {
          if (!editing) {
            this.model.id = counterpart.id;
            this.isEditing = true;
            const url = this.router.createUrlTree([this.model.id], {
              relativeTo: this.route,
            });
            this.location.go(url.toString());
          }
          return this.model;
        })
      )
      .subscribe({
        next: (result: Counterpart) => {
          const msg = editing ? "Usuário alterado." : "Usuário cadastrado.";

          this.accounts.forEach((account) => {
            if (result.id) {
              account.counterpartId = result.id;
            }
          });

          this.registerAccounts(msg);
        },
        error: (result) => {
          let err = result;
          if (result.status === 409) {
            err = "Contraparte já cadastrada!";
          } else if (result.message) {
            err = result.message;
          }

          this.snackBarService.open(err, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
        },
      });
  }

  register() {
    const editing = this.isEditing;

    Object.values(this.frm.controls).forEach((c) => {
      c.markAsTouched();
      c.updateValueAndValidity();
    });

    this.canValidate = true;
    const errors = this.getErrors();

    if (this.frm.invalid || errors.length > 0) {
      return throwError(() => "Verifique os campos destacados.");
    }
    const data = Object.assign({}, this.model);

    data.document = this.validator.sanitize(data.document);

    const method = editing
      ? this.service.UpdateCounterpart(this.model.id, data)
      : this.service.RegisterUCounterpart(data);

    location.reload;

    return method;
  }

  registerAccounts(msg: string) {
    const method = this.service
      .UpdateCounterpartAccount(this.accounts)
      .subscribe({
        next: (result: CounterpartAccount[]) => {
          this.accounts = result;

          this.snackBarService.open(msg, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
        },
        error: (result) => {
          let err = result;
          if (result.message) {
            err = result.message;
          }

          this.snackBarService.open(err, "OK", {
            verticalPosition: "top",
            horizontalPosition: "right",
          });
        },
      });

    return method;
  }

  hasError(prop: string, isAccount: boolean = false, index: number = null) {
    if (!this.canValidate) {
      return false;
    }
    let value: Counterpart | CounterpartAccount;

    if (isAccount && index >= 0) {
      value = this.accounts[index];
    } else {
      value = this.model;
    }

    return !this.validators[prop](value[prop]);
  }

  getErrors(): string[] {
    const validationErrors = [];

    Object.keys(this.validators).forEach((k) => {
      if (
        (k == "bank" || k == "branch" || k == "account") &&
        this.accounts.length > 0
      ) {
        this.accounts.forEach((account) => {
          if (!this.validators[k](account[k])) {
            validationErrors.push(k);
          }
        });
      } else if (!this.validators[k](this.model[k])) {
        validationErrors.push(k);
      }
    });

    return validationErrors;
  }

  addBank() {
    this.accounts.push(new CounterpartAccount());
  }
}
